import { CancelToken } from 'apisauce';
import { useQuery } from 'react-query';

import { ApiRequestError, getBuilding, getSimpleEnergyAnalyses } from '../../services/api';
import { DetailedBuildingDetails, SimpleEnergyAnalysis } from '../../types/building';
import { queryKeys } from '../../utils/react-query';

export const useBuildingData = (energiobjektId?: string) => {
  const { error, isLoading, data } = useQuery<DetailedBuildingDetails | undefined, ApiRequestError>(
    [queryKeys.building, energiobjektId],
    ({ signal }) => {
      const source = CancelToken.source();

      const request = getBuilding(energiobjektId, source.token);

      // Cancel the request if React Query signals to abort
      signal?.addEventListener('abort', () => {
        source.cancel('Query was cancelled by React Query');
      });

      return request;
    },
    {
      enabled: !!energiobjektId
    }
  );

  return {
    buildingError: error,
    buildingLoading: isLoading,
    building: data
  };
};

export const useBuildingEnergyAnalyses = (buildingId?: string) => {
  const { data, error, isLoading, refetch } = useQuery<SimpleEnergyAnalysis[] | undefined, ApiRequestError>(
    [queryKeys.energyAnalysisList, buildingId],
    () => getSimpleEnergyAnalyses(buildingId),
    {
      enabled: !!buildingId
    }
  );

  return {
    simpleEnergyAnalyses: data ?? [],
    simpleEnergyAnalysesError: error,
    simpleEnergyAnalysesLoading: isLoading,
    refreshSimpleEnergyAnalyses: refetch
  };
};
